module.exports = { 
  userInfo: { 
    logout: "退出登录",
    changeAvatar: "更换头像",
    firstName: "名",
    lastName: "姓",
    sex: "性别",
    male: "男",
    female: "女",
    dateOfBirth: "出生日期",
    bindPhoneNumber: "绑定手机号",
    change: "更换",
    saveBtn: "保存",
    editProfile: "编辑个人信息",
    decTitle: "在下方查看和编辑您的个人信息。",
    userId: "用户ID：",
    accountEmail: "帐户电子邮件地址：",
    changePassword: "修改密码",
    changeAccount: "修改帐户电子邮件地址",
    email: "联系电子邮件",
    phone: "电话号码(例如.201-555-5555)",
    gender: "性别",
    birthday: "生日",
    cancel: "取消",
    currentPassword: "输入当前密码",
    newPassword: "输入新密码",
    againNewPassword: "再次输入新密码",
    currentEmail: "输入当前电子邮件地址",
    emailCode: "输入验证码",
    newEmail: "输入新电子邮件地址",
    titlePassword: "更改密码",
    titleEmail: "更改帐户电子邮件地址",
    sendCode: "发送验证码",
  },
  changePhone: { 
    changePhoneNumber: "更换手机号码",
    authentication: "身份验证",
    complete: "完成",
    boundPhoneNumber: "已绑定的手机号码",
    verificationCode: "验证码",
    nextStep: "下一步",
    enterNewNumber: "输入新号码",
    sumbit: "提交",
    congratulations: "恭喜您，更换手机已完成！",
    securityServiceTips: "安全服务提示",
    bindingSecurity: "绑定手机可提高帐号安全性",
    phoneAccount: "一个手机号只能绑定一个帐号",
  },
  message: {
    noNews: "你还没有消息～",
    goHomepage: "去首页看看",
    noOders: "你还没有订单哦～",
    noQuestions: "你还没有提问～",
    noAnswer: "你还没有回答～",
    noSalesOrder: "你还没有售后订单哦～",
    noCommented: `你还没有评价～`,
    noBrowsing: "你还没有浏览记录～",
  },
  order: {
    allOrders: "所有订单",
    pendingPayment: "待付款",
    beShipped: "待发货",
    beReceived: "待收货",
    beEvaluated: "待评价",
    beGrouped: "待成团",
    commoditySearch: "商品名称/订单号",
    commodity: "宝贝",
    unitPrice: "单价",
    amount: "数量",
    receiver: "收货人",
    realPayment: "实付款",
    state: "状态",
    operate: "操作",
    orderNumber: "订单号",
    afterSalesReview: "售后审核中",
    refunding: "退款中",
    returning: "退货中",
    refundSuccessfully: "退款成功",
    refundFailed: "退款失败",
    auditNotPassed: "审核不通过",
    aftermarketReviewIn: "售后评审中",
    refundRefused: "退货完成，拒绝退款",
    reviewPassed: "售后审核通过",
    includingFreight: "含运费",
    remainingTime: "剩余时间",
    minute: "分",
    completed: "已完成",
    closed: "已关闭",
    orderDetails: "订单详情",
    afterDdetails: "售后详情",
    toPay: "去付款",
    remindShipment: "提醒发货",
    confirmationReceipt: "确认收货",
    buyAgain: "再次购买",
    cancelOrder: "取消订单",
    returnRefund: "退货/退款",
    evaluation: "评价",
    checkLogistics: "查看物流",
  },
  qalist: {
    myQuestion: "我的提问",
    noAnswer: "暂无回答",
    myAnswer: "我的回答",
    answerTo: "回答于",
  },
  orderAfterSale: {
    afterSale: "售后中",
    completed: "已完成",
    refundAmount: "退款金额",
    applicationTime: "申请时间",
    afterSalesNumber: "售后编号",
    platformIntervention: "申请平台介入",
  },
  myEvaluate: {
    evaluationTime: "评价时间",
    viewReviews: "查看评价",
    toReview: "去追评",
    myComment: "我的评价",
    evaluationDetails: "评价详情",
    initialEvaluation: "初次评价",
    additionalEvaluation: "追加评价",
    fillEvaluation: "填写商品评价",
    pleaseComment: "请输入您的评语",
    inTotal: "共",
    sheet: "张",
    alsoUpload: "还可以上传",
    submitReview: "提交评价",
    myOrder: "我的订单",
    evaluation: "评价",
    productSatisfactionScore: "商品满意度评分",
    commodityImpression: "商品印象",
    evaluationList: "评价晒单",
  },
  browseRecords: {
    browseFootprint: "浏览足迹",
    deleteFootprint: "删除足迹",
    seeDetails: "查看详情",
  }
} 


// WEBPACK FOOTER //
// ./src/assets/lang/zh-cn/userCenter/index.js